import { all, call, put, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  requestUser,
  userAccepted,
  userRejected,
} from '../../actions/userAccount/user/fetchUser'
import { switchLanguage } from '../../actions/userAccount/user/switchLanguage'
import { countryDictionaryAccepted } from '../../actions/userObject/settings/countryDictionary'
import { changeDateTimeFormat } from '../../actions/userObject/settings/dateTimeFormat'
import { objectTypeAccepted } from '../../actions/userObject/settings/objectTypes'
import {
  AuthorizationActions,
  NotificationActions,
  UserAccountActions,
} from '../../reducers/userAccount/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { Mixpanel } from '../../utils/Mixpanel'
import loadEverything from '../../models/User/loadEverything'
import { mapResponseNotification } from '../../models/Notifications/request/handleResponse'
import { FacilitiesActions } from '../../reducers/facilities/actionNames'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import mapResponseDatesToColumns from '../../models/Calendar/mappers/mapResponseDatesToColumns'
import { PriceConfigurationActions } from '../../reducers/price/actionNames'
import mapResponseToPriceConfiguration from '../../models/Price/mappers/mapResponseToPriceConfiguration'
import saveCookies from '../../models/User/saveCookies'

function *saveCookiesInApi() {
  const allNames = fetchActionsName(ActionNames.SaveCookiesInApi)
  const [allService] = yield all([
    take(allNames.output),
    put(callFetch(allNames.input, allNames.output, saveCookies)),
  ])
  yield call(allService.service)
}

function* fetchUser() {
  try {
    const allNames = fetchActionsName(ActionNames.LoadEverything)
    const [allService] = yield all([
      take(allNames.output),
      put(callFetch(allNames.input, allNames.output, loadEverything)),
    ])

    const allData = yield call(allService.service)

    const user = allData.user

    const [countries, objectTypes] = [allData.countries, allData.object_types]

    Mixpanel.reset()

    const provider = localStorage.getItem('provider')

    Mixpanel.identify(user.id)

    Mixpanel.register({
      Email:
        user.id_worker && Number(user.id_worker)
          ? user.owner_email
          : user.email,
      ID: user.id,
      Language: user.savedLanguage,
      'Subaccount ID':
        user.id_worker && Number(user.id_worker) ? user.id_worker : undefined,
      'Subaccount Email':
        user.id_worker && Number(user.id_worker) ? user.email : undefined,
    })

    Mixpanel.track('Login Completed', {
      Email: user.email,
      ID: user.id,
      'Login Method': provider ? provider : 'E-mail',
    })
    Mixpanel.people.union(user.id, 'Platforms Used', 'Web')

    if (user.id_worker && Number(user.id_worker)) {
      localStorage.setItem('workerId', user.id_worker)
    }

    yield all([
      put(userAccepted(user)),
      put(countryDictionaryAccepted(countries)),
      put(objectTypeAccepted(objectTypes)),
      put(changeDateTimeFormat(user.dateFormat, user.timeFormat)),
      put(switchLanguage(user.savedLanguage, false)),
      put({
        type: NotificationActions.Put,
        notifications: mapResponseNotification(allData.notifications),
      }),
      put({
        type: FacilitiesActions.FacilitiesAccepted,
        payload: allData.amentity,
      }),
      put({
        type: CalendarActions.FetchSelectedColumns,
        columns: mapResponseDatesToColumns({
          items: allData.calendar_days,
        } as any),
      }),
      put({
        type: PriceConfigurationActions.PriceConfigurationAccepted,
        configuration: mapResponseToPriceConfiguration({
          items: [allData.price_settings],
        } as any)[0],
      }),
    ])
  } catch (e) {
    yield put(userRejected(e.message))
  }
}

function* userIsAuthorized() {
  yield put(requestUser())
}

export default function*() {
  yield takeLatest(AuthorizationActions.AuthorizationGranted, userIsAuthorized)
  yield takeLatest(UserAccountActions.RequestUserData, fetchUser)
  yield takeLatest(UserAccountActions.SaveCookies, saveCookiesInApi)
}
